import { getAccessToken, getSoDetail, vf2Describe, getGuestId, getGuestList, getGuestDetail, getAgentDetail } from "../../store/visitForm2";
import { createFetch } from "../../utils";

const { URL_PREFIX } = window;

export const registerLoginInfo = ({ token, expired, soId, guestId, mainGuest, isLoginAsSalesAgent }) => ({
  type: getAccessToken,
  payload: {
    token,
    expired,
    soId,
    guestId,
    mainGuest, 
    isLoginAsSalesAgent
  },
});

export const sendEmailUrl =( guestId ) => async ( dispatch, getState ) => {
  const { accessToken } = getState().vf2;

  try {
    await createFetch({
      path: `vf2/guest/send-vf2-link/${guestId}`,
      method: "POST",
      body: {},
      accessToken,
    });
    return
  } catch (error) {
    console.log(error)
  }
};

export const registerGuestId = (guestID) => async (dispatch) => {
  dispatch({
    type: getGuestId,
    payload: guestID,
  });

  await dispatch(fetchGuestDetail());
};

export const fetchGuestDetail = () => async (dispatch, getState) => {
  const { accessToken, guestId, isLoginAsSalesAgent, soId } = getState().vf2;
  try {
    if(guestId){
      const guestDetail = await createFetch({
        path: `vf2/guest/${guestId}`,
        accessToken,
        method: "GET",
      });
      
      dispatch({
        type: getGuestDetail,
        payload: { 
          detail: guestDetail.guestRecord,
        },
      });

    }
  } catch (error) {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Redirect to /vf2/logout if token expired
      window.location.href = `${URL_PREFIX}/vf2/logout`;
      return;
    }
  }
};

export const fetchAgentDetail = () => async (dispatch, getState) => {
  const { accessToken, isLoginAsSalesAgent, soId, guestId } = getState().vf2;
  try {
    if(isLoginAsSalesAgent){
      const agentDetail = await createFetch({
        path: `vf2/so/${soId}`,
        accessToken,
        method: "GET",
      });
      
      dispatch({
        type: getAgentDetail,
        payload: { 
          detail: agentDetail.soRecord,
        },
      });

      if(!guestId){
        dispatch({
          type: getGuestDetail,
          payload: { 
            detail: {},
          },
        });
      }

    }
  } catch (error) {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Redirect to /vf2/logout if token expired
      window.location.href = `${URL_PREFIX}/vf2/logout`;
      return;
    }
  }
};

export const fetchGuestList = () => async (dispatch, getState) => {
  const { accessToken, soId } = getState().vf2;
  const guest = await createFetch({
    path: `vf2/guest/so/${soId}`,
    accessToken,
    method: "GET",
  });
  dispatch({
    type: getGuestList,
    payload: guest.guestRecord?.records,
  });
};


export const getSalesOrderDetail = () => async (dispatch, getState) => {
  const { accessToken, soId } = getState().vf2;
  const soDetail = await createFetch({
    path: `vf2/so/${soId}`,
    accessToken,
    method: "GET",
  });

  dispatch({
    type: getSoDetail,
    payload: soDetail.record,
  });
};

export const getDescibe = () => async (dispatch, getState) => {
  const { accessToken } = getState().vf2;
  const describe = await createFetch({
    path: `/vf2/describe?objectName=Guest__c`,
    accessToken,
    method: "GET",
  });

  const fieldsDescribe = describe.record.fields.map((field) => ({
        picklistValues: field.picklistValues,
        name: field.name,
        label: field.label,
      }))

  dispatch({
    type: vf2Describe,
    payload: fieldsDescribe,
  });
};

export const editGuestDetail = (data, guestId, callback = async () => {}, type = 'list') => async (dispatch, getState) => {
  // const getLocalStorage = JSON.parse(localStorage.getItem("persist:root"));
  // const getAccessToken = JSON.parse(getLocalStorage.vf2);
  // const accessToken = getAccessToken.accessToken;
  const { accessToken } = getState().vf2;
  try {
    const guestDetail = await createFetch({
      path: `vf2/guest/edit/${guestId}`,
      method: "PATCH",
      body: data,
      accessToken,
    });
    if(type === 'detail'){
      await callback(guestDetail.guestRecord);
    }else{
      await callback();
    }
  } catch (error) {
    throw error
  }
};



export const returnUpdate = (data) => ({
  type: getGuestDetail,
  payload:{detail: data},
});

export const updateGuest = async (data) => {
  const guestDetail = await createFetch({
    path: "vf2/allocate",
    method: "PATCH",
    body: data,
  });
  return guestDetail;
};
export default null;
